// Create a new custom element named custom-details
class CustomDetails extends HTMLElement {
    constructor() {
      super();
      this._onSummaryClickedListener = this._onSummaryClicked.bind(this);
      this._onDocumentClickListener = this._onDocumentClick.bind(this);
    }
  
    static get observedAttributes() {
      return ['open'];
    }
  
    connectedCallback() {
      // Find summary element
      const summary = this.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', this._onSummaryClickedListener);
      }
      
      // Add event listener to document to catch outside clicks
      document.addEventListener('click', this._onDocumentClickListener);
      
      // Initialize state
      this._updateUI();
    }
  
    disconnectedCallback() {
      const summary = this.querySelector('summary');
      if (summary) {
        summary.removeEventListener('click', this._onSummaryClickedListener);
      }
      
      // Remove event listener when component is destroyed
      document.removeEventListener('click', this._onDocumentClickListener);
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'open') {
        this._updateUI();
        this._updateHeaderClass();
      }
    }
  
    get open() {
      return this.hasAttribute('open');
    }
  
    set open(value) {
      if (value) {
        this.setAttribute('open', '');
      } else {
        this.removeAttribute('open');
      }
    }
  
    // Check if this is a level 1 custom-details
    isLevel1() {
      // Check if the parent element is in the main menu
      // You can adjust this selector based on your DOM structure
      const parent = this.parentElement;
      const grandParent = parent ? parent.parentElement : null;
      
      // Check common cases for level 1 menu
      return (
        (parent && parent.tagName === 'LI' && grandParent && grandParent.classList.contains('main-menu')) ||
        (parent && parent.classList.contains('nav-item')) ||
        (parent && parent.classList.contains('menu-level-1')) ||
        // Add other conditions if needed
        (parent && parent.tagName === 'UL' && parent.classList.contains('header-menu'))
      );
    }
  
    _onSummaryClicked(event) {
      event.preventDefault();
      event.stopPropagation(); // Prevent event from bubbling up to document
      
      // If currently closed, open it and close all other level 1 custom-details if this is level 1
      if (!this.open) {
        // Check if this is a level 1 custom-details
        if (this.isLevel1()) {
          // Close all other level 1 custom-details
          document.querySelectorAll('custom-details').forEach(details => {
            // Only process other level 1 custom-details
            if (details !== this && details.isLevel1() && details.open) {
              details.open = false;
            }
          });
        } else {
          // If not level 1, only close custom-details at the same level within the same container
          const parent = this.parentElement;
          if (parent) {
            const container = parent.parentElement;
            if (container) {
              Array.from(container.children)
                .filter(child => child !== parent)
                .forEach(child => {
                  const details = child.querySelector('custom-details');
                  if (details && details.open) {
                    details.open = false;
                  }
                });
            }
          }
        }
        
        this.open = true;
      } else {
        // If currently open, close it
        this.open = false;
      }
      
      // Dispatch toggle event to notify other components of the change
      this.dispatchEvent(new CustomEvent('toggle', { bubbles: true }));
    }
  
    _onDocumentClick(event) {
      // If clicking on any custom-details, ignore
      if (event.target.closest('custom-details')) {
        return;
      }
      
      // If clicking on custom-tab-head-item, ignore
      if (event.target.closest('custom-tab-head-item')) {
        return;
      }
      
      // If clicking outside, close all open custom-details
      if (this.open) {
        this.open = false;
      }
    }
  
    _updateUI() {
      const summary = this.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', this.open ? 'true' : 'false');
      }
    }
    
    _updateHeaderClass() {
      const headerSection = document.querySelector('.shopify-section--header');
      if (!headerSection) return;
      
      // Check if any custom-details are still open
      const anyDetailsOpen = document.querySelector('custom-details[open]') !== null;
      
      if (anyDetailsOpen) {
        headerSection.classList.add('is-open');
      } else {
        headerSection.classList.remove('is-open');
      }
    }
  }
  
  // Register the new custom element
  if (!window.customElements.get('custom-details')) {
    window.customElements.define('custom-details', CustomDetails);
  }